import authenticationHandler from "../../services/api/authenticationHandler";
import Constants from "../../constants/text-constants";
import accountHandler from "../../services/api/accountHandler";

export const validateResetCode = async (username, resetCode) => {
    let response = {};
    const resp = await authenticationHandler.ValidateResetCode(username, resetCode);
    
    if (resp && !resp.Success) {
        if (resp.ErrorType === "invalid_reset_code") {
            response.error = Constants.INCORRECT_CODE_ENTERED;
        } else {
            response.error = Constants.FAILED_TO_VALIDATE;
        }
    }
    return response;
}

export const requestResetCode = async (username, email) => {
    const resp = await authenticationHandler.RequestPasswordReset(username, email);
    if (resp && resp.ErrorType === 'SYSTEM') {
        // Network issue - all other errors are treated as success for security reasons
        return false;
    }
    return true;
}

export const getPasswordHints = async () => {
    try {
        return await accountHandler.getPasswordHints();
    } catch (e) {
        console.warn("getPasswordhints failed");
        return null;
    }
}
